import { ScorerOpenView } from '../../../../types/advise';
import { TextBlock, TextSpan } from '../../../Atoms/Text';
import { joinWithAnd } from '../../../../utils/joinWithAnd';

/** Who is asked to score what: the engagement, the invitee's scope and role, and the supplier. */
export const ScorerScopeCard = ({ view }: { view: ScorerOpenView }) => {
  const supplier = view.supplier.supplier_name;
  const scope = view.all_categories ? 'all categories' : joinWithAnd(view.categories.map((category) => category.label));
  return (
    <section className="flex flex-col gap-2 rounded-lg border border-grey-2 bg-white p-5">
      <TextBlock
        size="lg"
        weight="semibold"
        color="grey8">
        {view.engagement.engagement_name}
      </TextBlock>
      <TextBlock color="grey8">
        Hi {view.invitee.first_name} — your UPSTACK Advisor is asking you to score {supplier}.
      </TextBlock>
      <TextSpan
        size="sm"
        weight="semibold"
        color="indigo"
        className="self-start rounded-full bg-secondary-100 px-3 py-1">
        Your scope: {scope}
        {view.invitee.role && ` — as ${view.invitee.role}`}
      </TextSpan>
      {view.note && (
        <TextBlock
          size="sm14"
          color="grey8"
          className="italic">
          {view.note}
        </TextBlock>
      )}
      <TextBlock
        size="sm"
        color="grey6">
        Score along as you watch the {supplier} demo — no need to finish before the call ends.
      </TextBlock>
    </section>
  );
};
